import * as React from "react";
// import 'moment/locale/fr';
// import { pure } from 'recompose';
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import SelectGrid from "@tunnel-components/@sharded/@widgets/select";
import * as Lodash from "lodash";
import * as cx from "classnames";
import * as Paths from "@tunnel-enums/index";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import DatePicker from "@tunnel-components/@sharded/@widgets/dataPicker";
import * as Styled from "@tunnel-components/@sharded/@styled/cart";
import * as i18next from "i18next"; // traduction
import * as Enums from "@tunnel-enums/index";
import * as Utils from "@Cyclope-Utils/index";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */

  //
  const {
    onEndDateChange,
    onStartDateChange,
    loading,
    onSubmit,
    cameraList,
    error,
    startDate,
    endDate,
    success,
    warningSevenDay,
    warning,
    btnloading,
    noIncidents,
    errorserver,
    selectedOptions,
    cameraIderror,
    onGetIdentifiantItem,
  } = props;

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */

  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.EXTRACTEDTHALESSEQUENCE,
  ]);

  /**
   * @description : retourne un boolean
   * @const
   * @name siteLoading
   * @type { boolean  }
   */
  const siteLoading: boolean =
    !Lodash.isUndefined(cameraList) &&
    !Lodash.isEmpty(cameraList) &&
    !Lodash.isNull(cameraList);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name react-datepicker
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      snackbarError={error}
      snackbar={success}
      someTextError={i18next.t("impossible d'extraire la sequence")}
      someTextSuccees={i18next.t("extraction de la video a reussi")}
      loading={loading}
      btnloading={btnloading}
      empty={noIncidents}
      error={errorserver}
    >
      {siteLoading && (
        <section className="tunnel-site animated fadeIn ">
          <BreadCrumb
            iconIncident={true}
            links1={Paths.PathsNamesEnums.EXTRACTOR}
            title={i18next.t("incidents")}
            breadText1={i18next.t("extraction de la sequence")}
          />
          <div className="contentAllSiteWithoutOnglet">
            <section className="columnsWithoutOnglet">
              <section className="content-wrapper">
                <section className="with--columns" id="columns">
                  <div className="formSimulator ">
                    <BoxGrid
                      title="EXTRACTEUR VIDÉO"
                      classNames="boderShadow"
                      error={!authorization}
                      onSubmit={onSubmit}
                      BtnTextSpan={i18next.t("extraire")}
                    >
                      <Styled.CartContainer>
                        <div className="extractionInfo left">
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("camera")} :</h2>
                            <SelectGrid
                              error={cameraIderror}
                              camera={true}
                              selectedOptions={selectedOptions}
                              onGetIdentifiantItem={onGetIdentifiantItem}
                              placeholder={i18next.t("rechercher une camera")}
                            />
                          </div>
                        </div>
                        <div className="extractionInfo left">
                          <div className={cx("titleAction")}>
                            <h2>{i18next.t("plage horaire")} : </h2>
                            <div className="blockDatePicker ">
                              <DatePicker
                                placeholder={i18next.t("date de debut")}
                                error={warning}
                                selectedValue={startDate}
                                onChangeSelected={onStartDateChange}
                              />
                            </div>
                            <div className="blockDatePicker ">
                              <DatePicker
                                placeholder={i18next.t("date de fin")}
                                error={warning}
                                selectedValue={endDate}
                                onChangeSelected={onEndDateChange}
                              />
                            </div>
                          </div>
                        </div>
                      </Styled.CartContainer>
                    </BoxGrid>
                  </div>
                </section>
              </section>
            </section>
          </div>
        </section>
      )}
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={warningSevenDay}
        someTextSuccees={i18next.t("video superieure a sept jours")}
      />
    </LayoutGrid>
  );
};

/** Valeurs par défaut des props */
Component.defaultProps = {};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  endDate?: any;
  onEndDateChange?: any;
  startDate?: any;
  onStartDateChange?: any;
  loading?: any;
  onSubmit?: any;
  cameraList?: any;
  onGetValue?: any;
  onSearchValue?: any;
  error?: any;
  success?: any;
  warningSevenDay?: any;
  warning?: any;
  btnloading?: any;
  noIncidents?: any;
  errorserver?: any;
  selectedOptions?: any;
  cameraIderror?: any;
  onGetIdentifiantItem?: any;
}
/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/tools/extractor/home/component.tsx